const ParticleWavesAnimation = () => {
  return (
    <iframe
      width="100%"
      height="500"
      src="https://keyframe-login-background.vercel.app"
      className="user-select-none fixed inset-x-0 bottom-0 z-0 opacity-50"
    />
  );
};

export default ParticleWavesAnimation;
